export default class BgIco {
    constructor() {
        this.xPositionArr = ['15%', '23%', '30.5%', '85%'];
        this.duration = 1200;
        this.repeatDelay = 2000;
        this.jump1Arr = [];
        this.jump2Arr = [];

        this.keyframes = {
            show: { opacity: 1 },
            jump: [
                { offset: 0.8, scale: '1.2 0.8', translate: 'none' },
                { offset: 1, scale: 1, translate: '0 -100%' },
            ],
        };

        this._init();
    }

    _init() {
        this._getEl();
        this._setPosition();
    }

    _getEl() {
        this.$icoArr = [...document.querySelectorAll('.js-bg-ico')];
    }

    _setPosition() {
        if (!this.$icoArr.length) return;

        let xIndexArr = [],
            yIndexArr = [];

        for (let i = 0; i < 4; i++) {
            xIndexArr = UTILS.getAddNewNumArr(0, 3, xIndexArr);
            yIndexArr = UTILS.getAddNewNumArr(0, 5, yIndexArr);
        }

        this.$icoArr.forEach(($ico, i) => {
            $ico.style.left = this.xPositionArr[xIndexArr[i]];
            $ico.style.top = `${yIndexArr[i] * 20}%`;
        });
    }

    execLoop() {
        this.$icoArr.forEach(($ico, i) => this._setAnimate($ico, i));
    }

    _setAnimate($ico, i) {
        const $img = $ico.querySelector('img'),
            delay = i * 200;

        const options = {
            show: {
                delay: delay,
                duration: this.duration / 2,
                fill: 'forwards',
            },
            jump1: {
                delay: delay,
                duration: this.duration / 2,
                easing: CONFIG.EASING.easeOutCubic,
            },
            jump2: {
                delay: delay + this.duration / 2,
                direction: 'reverse',
                duration: this.duration / 2,
                easing: CONFIG.EASING.easeOutCubic,
            },
        };

        const animiateShow = $img.animate(this.keyframes.show, options.show);
        this.jump1Arr.push($img.animate(this.keyframes.jump, options.jump1));
        this.jump2Arr.push($img.animate(this.keyframes.jump, options.jump2));

        this.jump2Arr[i].onfinish = () => this._setRepeat(i);
    }

    _setRepeat(i) {
        if (this.$icoArr.length - 1 != i && !this.isRepeat) return;

        this.isRepeat = true;
        i = UTILS.getRandom(0, 3);

        this.jump1Arr[i].effect.updateTiming({ delay: this.repeatDelay });
        this.jump2Arr[i].effect.updateTiming({ delay: this.repeatDelay + this.duration / 2 });
        this.jump1Arr[i].play();
        this.jump2Arr[i].play();
    }
}
